module.exports = __webpack_public_path__ + "static/desktop/img/material-mobile-album.c0e2d83b.png";